<template>
    <label for="show-timestamps">
        <input id="show-timestamps" @change="handleChange" type="checkbox" name="show-timestamps" v-model="value" class="mr-1" />
        Show Timestamps
    </label>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps(['defaultValue']);

const emit = defineEmits(['update:modelValue']);

const value = ref(props.defaultValue);

function handleChange() {
    emit('update:modelValue', value.value);
}

watch(() => props.defaultValue, (newValue) => {
    value.value = newValue;
});
</script>
